<div class="container">
    <h2 mat-dialog-title>Delete Supplier</h2>

    <div mat-dialog-body class="dialog-body">
        <p>Are you sure you want to delete this supplier?</p>

        <div class="item" *ngFor="let item of items">
            <span class="label">{{ item.title }}: </span>
            <span class="value" *ngIf="item.format == undefined">{{ this.supplier[item.name] }}</span>
            <span class="value" *ngIf="item.format === 'phone'">{{ this.supplier[item.name] | phone }}</span>
        </div>
    </div>

    
    <div class="form-actions" mat-dialog-actions>
        <button mat-flat-button color="accent" (click)="remove()">Delete</button>
        <button mat-flat-button class="cancel" (click)="cancel()">Cancel</button>
    </div>
</div>